import React from "react";
import { Building2 } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";

/**
 * Inline company indicator for an entry. Renders only in "See all" mode.
 *
 * Visual: a fixed-width, right-aligned text column with a small building
 * icon — matches the dropdown style (slate text, no pill), so entries
 * across rows line up like a virtual column.
 */
export default function CompanyBadge({ entry, className = "" }) {
  const { activeId, companies } = useCompany();
  if (activeId !== "__all__") return null;
  const co = entry?.company_id ? companies.find((c) => c.id === entry.company_id) : null;
  return (
    <div
      className={`hidden sm:flex items-center gap-1 w-[140px] shrink-0 text-xs font-medium text-slate-700 truncate ${className}`}
      title={co?.name || ""}
      data-testid={co ? `company-badge-${co.id}` : "company-badge-empty"}
    >
      {co && (
        <>
          <Building2 className="h-3 w-3 text-slate-400 shrink-0" />
          <span className="truncate">{co.name}</span>
        </>
      )}
    </div>
  );
}

